import React from "react";
import { useTranslation } from "react-i18next";
import { ProfileContactWrapper } from "./styled";
import {
  Box,
  HeadingStyled,
  HeadingStyledSm,
  TextStyled,
} from "../../styled/Elements";

/**
 * Contact Details on my-profile. Prefers contact_detail fields; falls back to
 * account phone/email from signup when contact_details was never created.
 */
const ProfileContact = ({ details, fallbackPhone, fallbackEmail }) => {
  const { t } = useTranslation();
  const mobile =
    (details?.contact_phone && String(details.contact_phone).trim()) ||
    (fallbackPhone && String(fallbackPhone).trim()) ||
    "";
  const email =
    (details?.contact_email && String(details.contact_email).trim()) ||
    (fallbackEmail && String(fallbackEmail).trim()) ||
    "";
  const office =
    details?.contact_office_phone && String(details.contact_office_phone).trim();

  return (
    <ProfileContactWrapper>
      <HeadingStyled size="24px">{t("ContactDetails")}</HeadingStyled>
      <Box className="w-100 d-flex gap-2 mt-2 flex-wrap">
        {office ? (
          <Box className="contactRow">
            <TextStyled>{t("office")}</TextStyled>
            <HeadingStyledSm
              className="dirEng"
              size="16px"
              family="var(--semiBold)"
            >
              {office}
            </HeadingStyledSm>
          </Box>
        ) : null}
        <Box className="contactRow">
          <TextStyled>{t("MobileNumber")}</TextStyled>
          <HeadingStyledSm
            className="dirEng"
            size="16px"
            family="var(--semiBold)"
          >
            {mobile}
          </HeadingStyledSm>
        </Box>
        <Box className="contactRow">
          <TextStyled>{t("email")}</TextStyled>
          <HeadingStyledSm
            className="dirEng"
            size="16px"
            family="var(--semiBold)"
          >
            {email}
          </HeadingStyledSm>
        </Box>
      </Box>
    </ProfileContactWrapper>
  );
};

export default ProfileContact;
